import { Link } from "react-router-dom";
import MarketingLayout from "@/components/public/MarketingLayout";
import PublicBreadcrumb from "@/components/public/PublicBreadcrumb";
import { Button } from "@/components/ui/button";

export default function BillingCanceledPage() {
  return (
    <MarketingLayout>
      <section className="mx-auto max-w-3xl px-5 py-24 text-center md:px-8">
        <div className="rounded-[32px] border border-slate-200 bg-white p-10 shadow-sm">
          <div className="text-left"><PublicBreadcrumb backTo="/pricing" backLabel="Torna ai piani" currentLabel="Checkout annullato" /></div>
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-700">Checkout annullato</div>
          <h1 className="mt-4 font-display text-5xl font-black text-slate-950">Nessun addebito e stato effettuato.</h1>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">Puoi tornare ai piani, cambiare opzione o parlare con noi per una configurazione assistita.</p>
          <div className="mt-8 flex justify-center gap-3">
            <Button asChild className="rounded-full bg-[#0f172a] px-6 hover:bg-slate-800"><Link to="/pricing">Torna ai piani</Link></Button>
            <Button asChild variant="outline" className="rounded-full border-slate-300 bg-white px-6"><Link to="/contact">Richiedi demo</Link></Button>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
